import React from 'react'
import FilterButton from './FilterButton';
import OptionButton from './OptionButton';


export default function SearchPanelFilterTrafficRegulation(props) {
    const anchorRef = React.useRef(null);
    
    return (
        <div className={"searchpanel-collapsed " + (props.searchPanelVisible ? "searchpanel-visible" : "")}>
                        
            <div ref={anchorRef} className="searchpopupshow" />

            <div className="searchfilters">
                <FilterButton label="申請日"
                    userAuthorities={props.userAuthorities}
                    keyword={props.keyword}
                    filters={props.filters}
                    width={props.width}
                    height={props.height}
                    anchorRef={anchorRef}
                    viewtype={props.viewtype}
                    isMobileMode={props.isMobileMode}
                    updateShowFiltersInfo={props.updateShowFiltersInfo}
                    onApplyFilter_date={props.onApplyFilter_date}
                    onClick={props.onSearchFilterClick}

                    isDisabled={false}
                    isShow={true}

                    popupKind={'date'}
                    filterKind={'applicationDate'}
                    filterKind_str={"applicationDate_str"}
                    filterKind_end={"applicationDate_end"}
                    DateTime_str={props.filters.applicationDate_str}
                    DateTime_end={props.filters.applicationDate_end}
                />
                <FilterButton label="ステータス"
                    userAuthorities={props.userAuthorities}
                    keyword={props.keyword}
                    filters={props.filters}
                    width={props.width}
                    height={props.height}
                    anchorRef={anchorRef}
                    updateShowFiltersInfo={props.updateShowFiltersInfo}
                    viewtype={props.viewtype}
                    isMobileMode={props.isMobileMode}
                    onApplyFilter={props.onApplyFilter}
                    onClick={props.onSearchFilterClick}
                    
                    isDisabled={false}
                    isShow={true}
                    isapplicationStatus={true}

                    popupKind={'list'}
                    masterKind={'applicationStatus'}
                    filterKind={'applicationStatus'}
                    targetTypes={props.filters.applicationStatus}
                />

                <FilterButton label="規制期間"
                    userAuthorities={props.userAuthorities}
                    keyword={props.keyword}
                    filters={props.filters}
                    width={props.width}
                    height={props.height}
                    anchorRef={anchorRef}
                    viewtype={props.viewtype}
                    isMobileMode={props.isMobileMode}
                    updateShowFiltersInfo={props.updateShowFiltersInfo}
                    onApplyFilter_date={props.onApplyFilter_date}
                    onClick={props.onSearchFilterClick}

                    isDisabled={false}
                    isShow={true}

                    popupKind={'date'}
                    filterKind={'restrictedDateTime'}
                    filterKind_str={"restrictedDateTime_str"}
                    filterKind_end={"restrictedDateTime_end"}
                    DateTime_str={props.filters.restrictedDateTime_str}
                    DateTime_end={props.filters.restrictedDateTime_end}
                />

                <OptionButton label="オプション" onClick={props.onSearchOptionClick} />
            </div>
        </div>
    );

}
